export const SIMPLE_COGNITIVE_WORKFLOW = 'illuminate-simple-workflow';
export const CATEGORY_ID_TRANSLATE = '3b2b2ff8-44aa-4db4-9b71-ff96c3bf5923';
export const CATEGORY_ID_TRANSCRIPTION = '67cd4dd0-2f75-445d-a6f0-2f297d6cd182';

const getEngineIds = () => {
  const config = typeof window !== 'undefined' ? window.config : undefined;
  return {
    glcIngestor:
      config?.defaultDAGTemplateEngineId?.glcIngestor ??
      'da093aca-2a6b-4577-8bfe-2b19a2f2faea',
    transcription:
      config?.defaultDAGTemplateEngineId?.transcription ??
      '01e54769-c448-4ece-a500-4fab5b49b722',
    outPutWriter:
      config?.defaultDAGTemplateEngineId?.outPutWriter ??
      '8eccf9cc-6b6d-4d7d-8cb3-7ebf4950c5f3',
    speakerSeparation:
      config?.defaultDAGTemplateEngineId?.speakerSeparation ??
      'cbfa6c21-ad7a-4fba-a6c4-d6d933b04e2d',
    chunk:
      config?.defaultDAGTemplateEngineId?.chunk ??
      '8bdb0e3b-ff28-4f6e-a3ba-887bd06e6440',
    translate:
      config?.defaultDAGTemplateEngineId?.translate ??
      '3f4184df-cea3-41df-a678-a7432f23821e',
    textIO:
      config?.defaultDAGTemplateEngineId?.textIO ??
      'b09b9184-0d98-4ecc-8368-51e96c77cdf5',
  };
};
export const DEFAULT_DAG_TEMPLATE_DEFINITIONS = (() => {
  const engineIds = getEngineIds();
  return [
    {
      name: 'Transcription - English (Global)',
      description: 'English (Global)',
      tags: [SIMPLE_COGNITIVE_WORKFLOW],
      cognitiveCategoryId: CATEGORY_ID_TRANSCRIPTION,
      dagTemplateLanguage: 'Handlebars',
      dag: JSON.stringify({
        targetId:
          '{{#if TARGET_ID}} "{{{TARGET_ID}}}" {{else}} "{{{TDO_ID}}}" {{/if}}',
        notificationUris:
          '{{#if notificationUri}} ["{{{notificationUri}}}"] {{/if}}',
        clusterId: '{{#if clusterId}} "{{{clusterId}}}" {{/if}}',
        tasks: [
          {
            engineId: engineIds.glcIngestor,
            payload: {
              url: '{{{UPLOAD_URL}}}',
              playback: false,
              chunkType: 'audio',
              audioMimeType: 'audio/wav',
            },
            executionPreferences: { priority: -10 },
            ioFolders: [
              { referenceId: 'ingest-output', mode: 'chunk', type: 'output' },
            ],
          },
          {
            engineId: engineIds.transcription,
            executionPreferences: {
              priority: -5,
              parentCompleteBeforeStarting: true,
            },
            ioFolders: [
              {
                referenceId: 'transcription-input',
                mode: 'chunk',
                type: 'input',
              },
              {
                referenceId: 'transcription-output',
                mode: 'chunk',
                type: 'output',
              },
            ],
          },
          {
            engineId: engineIds.outPutWriter,
            executionPreferences: {
              priority: -10,
              parentCompleteBeforeStarting: true,
            },
            ioFolders: [
              {
                referenceId: 'ow-transcription-input',
                mode: 'chunk',
                type: 'input',
              },
            ],
          },
          {
            engineId: engineIds.speakerSeparation,
            payload: {
              diarization: 'speaker',
              speakerChangeSensitivity: '0.4',
            },
            executionPreferences: {
              priority: -5,
              parentCompleteBeforeStarting: true,
            },
            ioFolders: [
              { referenceId: 'ss-input', mode: 'chunk', type: 'input' },
              { referenceId: 'ss-output', mode: 'chunk', type: 'output' },
            ],
          },
          {
            engineId: engineIds.outPutWriter,
            executionPreferences: {
              priority: -10,
              parentCompleteBeforeStarting: true,
            },
            ioFolders: [
              { referenceId: 'ow-ss-input', mode: 'chunk', type: 'input' },
            ],
          },
        ],
        routes: [
          {
            parentIoFolderReferenceId: 'ingest-output',
            childIoFolderReferenceId: 'transcription-input',
          },
          {
            parentIoFolderReferenceId: 'transcription-output',
            childIoFolderReferenceId: 'ow-transcription-input',
          },
          {
            parentIoFolderReferenceId: 'ingest-output',
            childIoFolderReferenceId: 'ss-input',
          },
          {
            parentIoFolderReferenceId: 'ss-output',
            childIoFolderReferenceId: 'ow-ss-input',
          },
        ],
      }),
    },
    {
      // Spanish to English, as specified in VE-18550: the translate engine
      // (3f4184df-…) translates Spanish to English.
      name: 'Translation - Text (TXT) - Spanish to English',
      description: 'Text (TXT) - Spanish to English',
      tags: [SIMPLE_COGNITIVE_WORKFLOW],
      cognitiveCategoryId: CATEGORY_ID_TRANSLATE,
      dagTemplateLanguage: 'Handlebars',
      dag: JSON.stringify({
        targetId:
          '{{#if TARGET_ID}} "{{{TARGET_ID}}}" {{else}} "{{{TDO_ID}}}" {{/if}}',
        notificationUris:
          '{{#if notificationUri}} ["{{{notificationUri}}}"] {{/if}}',
        clusterId: '{{#if clusterId}} "{{{clusterId}}}" {{/if}}',
        tasks: [
          {
            engineId: engineIds.chunk,
            payload: {
              url: '{{{UPLOAD_URL}}}',
              // eslint-disable-next-line @cspell/spellchecker
              ffmpegTemplate: 'rawchunk',
            },
            executionPreferences: { priority: -10 },
            ioFolders: [
              { referenceId: 'chunkOutput', mode: 'chunk', type: 'output' },
            ],
          },
          {
            engineId: engineIds.textIO,
            payload: { method: 'rawChunks' },
            executionPreferences: {
              priority: -10,
              parentCompleteBeforeStarting: true,
            },
            ioFolders: [
              { referenceId: 'textInput', mode: 'chunk', type: 'input' },
              { referenceId: 'textOutput', mode: 'chunk', type: 'output' },
            ],
          },
          {
            engineId: engineIds.translate,
            payload: { useCacheURI: true, addToIndex: true },
            executionPreferences: {
              priority: -5,
              parentCompleteBeforeStarting: true,
            },
            ioFolders: [
              { referenceId: 'translationInput', mode: 'chunk', type: 'input' },
              {
                referenceId: 'translationOutput',
                mode: 'chunk',
                type: 'output',
              },
            ],
          },
          {
            engineId: engineIds.outPutWriter,
            payload: { mergeTextObjects: true },
            executionPreferences: {
              priority: -10,
              parentCompleteBeforeStarting: true,
            },
            ioFolders: [
              { referenceId: 'owInput', mode: 'chunk', type: 'input' },
            ],
          },
        ],
        routes: [
          {
            parentIoFolderReferenceId: 'chunkOutput',
            childIoFolderReferenceId: 'textInput',
          },
          {
            parentIoFolderReferenceId: 'textOutput',
            childIoFolderReferenceId: 'translationInput',
          },
          {
            parentIoFolderReferenceId: 'translationOutput',
            childIoFolderReferenceId: 'owInput',
          },
        ],
      }),
    },
  ];
})();
